import Outlet from '@/shared/models/Outlet';
import Tag from '@/shared/models/Tag';
import { HexColor } from '@/shared/models/common';

export interface DossierStackId {__dossierStackId: number}

export interface DossierStackData {
  outlet?: Outlet | null;
  description: string;
  color: HexColor | null;
}

export default class DossierStack extends Tag<DossierStackId> {
  size: number | null = null;
  isPersonal = false;

  update(data: DossierStackData): void {
    this.description = data.description;
    this.colorHex = data.color;
    if (data.outlet !== undefined) this.outletId = data.outlet?.id ?? null;
  }
}